import type { Environment } from '@sg/common';
import { detectExternalProvider, oidcUriNormalizer } from '../utils';
import type { SgApplicationConfiguration } from './types';

const PATHNAME_DETECT_REGEXP = new RegExp(`^(?:#/|#|/)(sg-borrower)(?:/|\\?|().*)?$`);
const HOSTNAME_DETECT_REGEXP = new RegExp(`^borrower(?:-.*)?\\.sharegain\\.com$`);
const ALLOWED_HOSTNAMES = [
  'bdashboard.sharegain.com'
];

declare module '@sg/pre-app-init/src/lib/application' {
  export interface SgCustomAppBranding {
    'sg-borrower': {
      hideTopBar: boolean;
    }
  }
}

export const sgBorrower: SgApplicationConfiguration<'sg-borrower'> = {
  name: 'sg-borrower',
  matcher: (location: Location) => {
    return PATHNAME_DETECT_REGEXP.test(location.pathname)
      || PATHNAME_DETECT_REGEXP.test(location.hash)
      || HOSTNAME_DETECT_REGEXP.test(location.hostname)
      || ALLOWED_HOSTNAMES.includes(location.hostname);
  },
  authType: 'oidc',
  branding: {
    css: 'sg-borrower-theme',
    theme: 'dark',
    logo: 'assets/sg-borrower/images/Logo_Borrower_Sharegain.svg',
    preLogo: 'assets/images/Logo_Horizontal_BlueGradient.svg',
    favIcon: 'assets/images/favicon/favicon.ico',
    hideTopBar: true,
    showSideBarExpender: false,
    sideMenuInitialState: 'closed',
    navBarLogoSrc: 'assets/sg-borrower/images/Logo_Borrower_Icon.svg',
    navBarHomeLink: 'sg-borrower/dashboard',
    showLogo: true,
    showAppName: false,
  },
  brandingMap: {
    standAlone: {
      name: 'standAlone',
      hideSideNav: true,
      custom: {
        hideTopBar: true
      }
    }
  },
  beforeLogin(env: Environment) {
    const { oidc } = env;
    env.oidc.acr_values = 'tenant:Borrower';

    const externalProvider = detectExternalProvider();
    if (externalProvider) {
      oidc.acr_values = 'tenant:Borrower idp:' + externalProvider;
    }

    const queryParams = new URLSearchParams(location.search);
    const locateId = queryParams.get('locateId');
    const brand = queryParams.get('brand');
    if(locateId || brand === 'standAlone') {
      oidc.prompt = 'none';
    }

    // by default, OIDC redirects are set under the assumption of a path app (hostname.com/SG-APPNAME)
    // when it's not the case we need to set the redirects properly.
    if (!PATHNAME_DETECT_REGEXP.test(location.pathname) && !PATHNAME_DETECT_REGEXP.test(location.hash)) {
      oidcUriNormalizer(oidc);
    }
  },
}
